import immagineCristina from "../../assets/immagineCristina.jpg";
import "./chisono.css";
import { Helmet } from "react-helmet";

export const ChiSono = () => {
    return (
        <>
            <title>
                <Helmet> Chi Sono </Helmet>
            </title>
            <section id="presentazione">
                <div className="container pb-5 pt-4">
                    <h2 className="fs-1 text-center mb-2">Mi Presento</h2>
                    <div className="row pt-4">
                        <div className="col-12">
                            <div className="pb-4 ps-md-3 pt-md-3 float-md-end w-50 margin-center pt-lg-0">
                                <img className="immagine-cristina" src={immagineCristina} alt="" />
                            </div>
                            <h3>Chi sono?</h3>
                            <p>
                                Mi chiamo Cristina, sono una doula e un tecnico di riabilitazione psichiatrica. Con la
                                nascita della mia bimba ho scoperto un mondo legato alla maternità ancora troppo
                                distante dal suo vero significato: troppo spesso le madri si ritrovano sommerse da
                                consigli non richiesti, pregiudizi, luoghi comuni che appesantiscono la loro esperienza
                                fin dall'inizio. Spesso la donna che è appena diventata madre si ritrova accompagnata da
                                un sostegno sterile, in cui non si sente in diritto di dire la propria, di affermarsi
                                con autorevolezza, di chiedere aiuto. Serve sostegno, pratico ed emotivo. Serve fare
                                informazione, precisa e tratta da fonti scientifiche ufficiali e riconosciute. Serve
                                tornare all'istinto, all'ascolto, alla fiducia. Serve consapevolezza del fatto che in
                                noi risiedano tutte le competenze necessarie per plasmare una nuova vita, per partorire
                                e crescere un neonato. Per tutti questi motivi ho intrapreso il percorso per diventare
                                una doula e oggi, se vorrete, sarò qui per aiutarvi. Mi trovate online e a Vigevano,
                                Pavia, Voghera e paesi limitrofi. Puoi guardare la mia videointervista cliccando{" "}
                                <a className="fs-5 textBlue underline-none" href="/videointervista">
                                    qui
                                </a>
                                .
                            </p>
                            <h3 className="mt-5">Chi è la Doula?</h3>
                            <p>
                                Il compito della doula è quello di permettere alla donna che sta per diventare madre di
                                prendere consapevolezza del suo ruolo, di scoprire le enormi e innate capacità che
                                risiedono dentro ogni madre, informandola, permettendole di concentrarsi su quello che
                                sta vivendo e legittimando ogni sensazione e vissuto. Una doula sostituisce un
                                “villaggio competente” che incoraggia e sostiene la madre. Scopri tutto ciò che posso
                                fare per te cliccando{" "}
                                <a className="fs-5 textBlue underline-none" href="/servizi">
                                    qui
                                </a>
                                .
                            </p>

                            <h3 className="mt-5">Perchè dovresti chiamare una Doula?</h3>
                            <ul className="mt-3 ps-3">
                                <li>
                                    Potresti aver bisogno di concentrarti solo sulla tua nuova famiglia, la doula si
                                    occuperà di tutto il resto;
                                </li>
                                <li>
                                    Può ascoltarti e darti informazioni basate sulle evidenze scientifiche, togliendoti
                                    confusione e ansie;
                                </li>
                                <li>
                                    Può riconoscere eventuali problematiche e inviarti da professionisti competenti;
                                </li>
                                <li>
                                    Riconosce e aiuta a far emergere il tuo ruolo di madre competente e consapevole;
                                </li>
                                <li>
                                    Supporta senza giudizio insicurezze, timori, dubbi, stanchezze e ti esorta ad
                                    esprimerli senza paura del giudizio degli altri;
                                </li>
                                <li>Può supportarti durante il travaglio;</li>
                                <li>Può aiutarti ad elaborare dei vissuti pesanti legati ad un parto precedente.</li>
                            </ul>
                            <h3 className="mt-5">Quale Formazione ha la Doula?</h3>
                            <p>
                                Le competenze e gli interventi di una doula riguardano sempre e soltanto la fisiologia
                                di una gravidanza e di un puerperio. Potrà riconoscere alcuni elementi di patologia e
                                rimandare a professionisti specializzati. Le competenze riguardano elementi di anatomia
                                femminile, fisiologia della gravidanza e del parto, fisiologia dell'allattamento, del
                                sonno e del puerperio; nozioni di babywearing, massaggio neonatale, strategie
                                comunicative e di sostegno alla madre, alimentazione complementare e auto svezzamento,
                                alimentazione in gravidanza e puerperio, rebozo e utilizzo di pannolini lavabili.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
